/** Browser-only grayscale for PDF assets. Missing `imageGrayscale` stays color. */

/**
 * Luminance grayscale on RGBA pixel data, in place. Same weights as CSS `grayscale()`,
 * so the PDF banner matches the editor preview; shared with the server PDF path.
 */
export function grayscalePixels(pixels: Uint8ClampedArray): void {
  for (let i = 0; i < pixels.length; i += 4) {
    const gray = Math.round(0.2126 * pixels[i] + 0.7152 * pixels[i + 1] + 0.0722 * pixels[i + 2]);
    pixels[i] = gray;
    pixels[i + 1] = gray;
    pixels[i + 2] = gray;
  }
}

export async function applyGrayscaleToDataUrl(src: string): Promise<string | null> {
  if (typeof document === 'undefined') return src;
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.naturalWidth || img.width;
      canvas.height = img.naturalHeight || img.height;
      if (canvas.width < 1 || canvas.height < 1) {
        resolve(src);
        return;
      }
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        resolve(src);
        return;
      }
      // Per-pixel instead of `ctx.filter`: Safari ships canvas filters disabled and
      // silently drew the banner in color.
      try {
        ctx.drawImage(img, 0, 0);
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        grayscalePixels(imageData.data);
        ctx.putImageData(imageData, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      } catch {
        resolve(src);
      }
    };
    img.onerror = () => resolve(null);
    img.src = src;
  });
}
